export default __webpack_public_path__ + "static/media/mikelg.fabec82c.jpg";